import { create } from 'zustand';
import { ApiUtils, RequestStrategyEnum, type StatementEntity, StatementsApi, type StatementSearchParams } from '@shared/api';

interface UseStatementsStore {
  loading: boolean;
  data: StatementEntity[];
  error: string | null;
  getStatements: (searchParams: StatementSearchParams, signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useStatementsStore = create<UseStatementsStore>((set) => ({
  loading: false,
  data: [],
  error: null,

  getStatements: ApiUtils.wrapperApi(async (searchParams, signal) => {
    try {
      set({ loading: true, error: null });
      const result = await StatementsApi.getStatements(searchParams, signal);
      set({ loading: false, data: result || [] });
    } catch (error) {
      set({ loading: false, error: ApiUtils.getApiError(error) });
    }
  }, RequestStrategyEnum.Debounce),

  clear: () => set({ loading: false, data: [], error: null }),
}));
